import {Box} from "@mui/material";
import * as React from "react";

export default function BelcoinsRules() {
    return (
        <Box>
            <table data-number-column="false">
                <tbody>
                <tr className={"table-header"}>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="4"><span
                            className="fabric-text-color-mark" data-renderer-mark="true"
                            data-text-custom-color="#ffffff">What are BelCoins awarded for?</span></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <p data-renderer-start-pos="36"><span
                            className="fabric-text-color-mark" data-renderer-mark="true"
                            data-text-custom-color="#ffffff">Value</span></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="49"><span
                            className="fabric-text-color-mark" data-renderer-mark="true"
                            data-text-custom-color="#ffffff">Who can award BelCoins?</span></p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="84">Participation in Event team contests</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="121">up to 5</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="129">Event team</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="148">Participation in PR team contests</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="182">up to 3</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="190">PR team</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="206">Speaker at Belcons</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="228">2</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="233">Event team</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="252">Speaker at external events</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="278">5</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="283">PR team</p>
                    </td>
                </tr>



                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="299">🎂 <a href={"https://my.belka-games.com/request/birthday"}>Birthday</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="316">5</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="321">System request</p>
                    </td>
                </tr>

                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="299">💍 <a href={"https://my.belka-games.com/request/wedding"}>Wedding</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="316">5</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="321">System request</p>
                    </td>
                </tr>

                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="299">👶 <a href={"https://my.belka-games.com/request/child"}>Child's Birth</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="316">5</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="321">System request</p>
                    </td>
                </tr>

                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="376">Seniority with the company (2 years)</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="411">10</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="417">System (automatic accrual)</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="436">Seniority with the company (4 years)</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="471">10</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="477">System (automatic accrual)</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="496">Seniority with the company (6 years)</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="530">10</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="536">System (automatic accrual)</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="555">Seniority with the company (8-9 years)</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="594">10</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="600">System (automatic accrual)</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="619">Seniority with the company (11-14 years)</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="660">10</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="666">System (automatic accrual)</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="685">Passing the probation period</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="703">5</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="708">
                            Office manager/regional director of the employment location</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="724"><a className="css-tgpl01"
                                                            title="/wiki/spaces/BC/pages/3204743252"
                                                            href="https://belka-games.atlassian.net/wiki/spaces/BC/pages/3204743252"
                                                            data-renderer-mark="true">Giving internal lectures</a>
                        </p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="755">4</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="760">HR team</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="724">Writing articles for external resources</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="764">3</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="769">PR team</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="837"><a className="css-tgpl01"
                                                            title="/wiki/spaces/GD/pages/1020363092"
                                                            href="https://belka-games.atlassian.net/wiki/spaces/GD/pages/1020363092"
                                                            data-renderer-mark="true">Belka Experts</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="854">2</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="859">Contest organizer</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="885"><a className="css-tgpl01"
                                                            title="/wiki/spaces/QA/pages/3643736081"
                                                            href="https://belka-games.atlassian.net/wiki/spaces/QA/pages/3643736081"
                                                            data-renderer-mark="true">Belka Bugs</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="899">up to 2</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="907">Contest organizer</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="986">Speaker at <a className="css-tgpl01"
                                                                      title="/wiki/spaces/GD/pages/3739091085"
                                                                      href="https://belka-games.atlassian.net/wiki/spaces/GD/pages/3739091085"
                                                                      data-renderer-mark="true">GD Breakfast</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark fabric-editor-alignment css-1mg5rgz"
                             data-align="center">
                            <p data-renderer-start-pos="1012">2</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="1017">Contest organizer</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="933">Radio interview</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark css-1mg5rgz" data-align="center">
                            <p data-renderer-start-pos="953">1</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310">
                        <p data-renderer-start-pos="958">PR team</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="1200"><a className="css-tgpl01"
                                                             title="https://belka-games.atlassian.net/wiki/spaces/BC/pages/3644981329/Belcoins#%D0%A0%D0%B0%D0%B7%D0%B2%D0%B8%D1%82%D0%B8%D0%B5-%D0%B2%D0%BD%D1%83%D1%82%D1%80%D0%B5%D0%BD%D0%BD%D0%B5%D0%B9-%D0%BA%D0%BE%D1%80%D0%BF%D0%BE%D1%80%D0%B0%D1%82%D0%B8%D0%B2%D0%BD%D0%BE%D0%B9-%D0%BA%D1%83%D0%BB%D1%8C%D1%82%D1%83%D1%80%D1%8B"
                                                             href="https://belka-games.atlassian.net/wiki/spaces/BC/pages/3644981329/Belcoins#%D0%A0%D0%B0%D0%B7%D0%B2%D0%B8%D1%82%D0%B8%D0%B5-%D0%B2%D0%BD%D1%83%D1%82%D1%80%D0%B5%D0%BD%D0%BD%D0%B5%D0%B9-%D0%BA%D0%BE%D1%80%D0%BF%D0%BE%D1%80%D0%B0%D1%82%D0%B8%D0%B2%D0%BD%D0%BE%D0%B9-%D0%BA%D1%83%D0%BB%D1%8C%D1%82%D1%83%D1%80%D1%8B"
                                                             data-testid="link-with-safety" data-renderer-mark="true">Developing
                            internal corporate culture</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark fabric-editor-alignment css-1mg5rgz"
                             data-align="center">
                            <p data-renderer-start-pos="1246">up to 2</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="1254">Event team</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="310" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="1282"><a className="css-tgpl01"
                                                             title="https://belka-games.atlassian.net/wiki/spaces/BC/pages/3644981329/Belcoins#%D0%A3%D1%87%D0%B0%D1%81%D1%82%D0%B8%D0%B5-%D0%B2--cross-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%B0%D1%85"
                                                             href="https://belka-games.atlassian.net/wiki/spaces/BC/pages/3644981329/Belcoins#%D0%A3%D1%87%D0%B0%D1%81%D1%82%D0%B8%D0%B5-%D0%B2--cross-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%B0%D1%85"
                                                             data-testid="link-with-safety" data-renderer-mark="true">Participation
                            in cross projects</a></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="140">
                        <div className="fabric-editor-block-mark fabric-editor-alignment css-1mg5rgz"
                             data-align="center">
                            <p data-renderer-start-pos="1312">up to 5</p>
                        </div>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="310" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="1320">Department heads</p>
                    </td>
                </tr>
                </tbody>
            </table>
        </Box>);
}